"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShotRecorder = exports.untilFor = void 0;
exports.assertFinish = assertFinish;
const models_1 = require("../models");
const assert_1 = require("./assert");
/** v1's surfaces by the v1 venue's panel ids. */
const SURFACES = {
    ground: models_1.CourtSurface.Court,
    leftWall: models_1.CourtSurface.LeftWall,
    rightWall: models_1.CourtSurface.RightWall,
    farWall: models_1.CourtSurface.BackWall,
    net: models_1.CourtSurface.Net,
};
/** v1 Launch's and Stroke's check on simParams, with their message. */
function assertFinish({ duration, bounces }, method) {
    (0, assert_1.assert)((duration !== null && duration >= 0) || (bounces !== null && bounces > 0), `${method}: one or both of (duration>=0, bounces>0) must be specified`);
}
/**
 * When v1's loop stops: at so many contacts, or at the duration when
 * bounces are off. The kernel also stops every flight at 5 s, where v1
 * would run on past a duration above that (or none).
 */
const untilFor = ({ bounces, duration }) => bounces !== null ? { kind: "bounces", count: bounces } : { kind: "time", seconds: duration ?? 0 };
exports.untilFor = untilFor;
/**
 * Lays a flight out as v1's loop leaves its Shot while the legacy kernel
 * steps (FlightKernel.record), so no path is recorded and converted. As in
 * v1, `start` is itself the first point's position, a bounce's timePosition
 * is the path sample it happened at (so contacts in one step share the
 * position the last of them left), the landing point is that sample's
 * position, and the peak climbs from `peakFrom` over the samples after the
 * first. Samples past `duration` (v1 stops at the first at or past it) are
 * dropped.
 */
class ShotRecorder {
    start;
    duration;
    ballPath = [];
    bounces = [];
    landingPoint = { x: 0, y: 0, z: -1 };
    peakHeight;
    stopped = false;
    constructor(start, duration, peakFrom) {
        this.start = start;
        this.duration = duration;
        this.peakHeight = peakFrom;
    }
    point(t, x, y, z) {
        if (this.stopped) {
            return;
        }
        if (this.ballPath.length === 0) {
            this.ballPath.push({ t: 0.0, pos: this.start });
            return;
        }
        this.ballPath.push({ t, pos: { x, y, z } });
        if (z > this.peakHeight) {
            this.peakHeight = z;
        }
        this.stopped = this.duration !== null && t >= this.duration;
    }
    contact(t, _x, _y, _z, surface, kind) {
        const last = this.ballPath[this.ballPath.length - 1];
        if (last.t !== t) {
            return;
        }
        this.bounces.push({ timePosition: last, surface: SURFACES[surface] });
        if (kind === "ground" && this.landingPoint.z === -1) {
            this.landingPoint = last.pos;
        }
    }
    deflect() { }
    truncate() { }
}
exports.ShotRecorder = ShotRecorder;
